import type { ProductConnection } from "@shopify/hydrogen/storefront-api-types";
import { NoResultFilter } from "@components/molecules/no-result-filter/index";
import { RightArrow } from "@components/atoms/Icons/components/right-arrow";
import { LeftArrow } from "@components/atoms/Icons/components/left-arrow";
import { usePagination } from "@models/interactions/use-pagination/index";
import { SolidButton } from "@components/atoms/base-button/index";
import { ProductGrid, ProductType } from "../product-grid/index.client";
import { useNavigate, Link } from "@shopify/hydrogen";
import ReactPaginate from "react-paginate";
import { translate } from "@locales";
import { ArticlePreview } from "@components/molecules/article-preview";

interface Props {
  itemsPerPage: number;
  products: ProductConnection;
  url?: string;
  productType?: ProductType;
  redirect: string;
  articles?: any;
}

export function PaginatedItems({
  itemsPerPage,
  products,
  redirect,
  url = "",
  productType,
  articles,
}: Props) {
  const { models, operations } = usePagination({
    collection: products,
    itemsPerPage,
    url,
    articles,
  });

  const navigate = useNavigate();

  if (!products.nodes.length && !articles) {
    return (
      <div className="lg:w-2/3 flex my-16 lg:my-0 lg:mt-60 justify-center">
        <NoResultFilter onClickHandler={() => navigate(redirect)} />
      </div>
    );
  }

  const reseter = `${products.nodes.at(0)?.id}-${products.nodes.at(-1)?.id}`;

  return (
    <div className="lg:w-2/3">
      <ProductGrid
        products={models.currentItems.products ?? models.currentItems}
        productType={productType}
        className="justify-center lg:justify-start"
      />
      {articles && (
        <div className="flex flex-wrap gap-5 m-5 ">
          {models.currentItems.blogs.map((article) => (
            <ArticlePreview article={article} />
          ))}
        </div>
      )}
      <div className="pt-8 pb-8 mt-5">
        <ReactPaginate
          key={reseter}
          previousLabel={
            1 === models.itemOffset + 1 ? (
              <></>
            ) : (
              <div className="flex">
                <LeftArrow width="35" height="25" />
                {translate("base.backward-page")}
              </div>
            )
          }
          nextLabel={
            models.pageCount === models.itemOffset + 1 ? (
              <></>
            ) : (
              <div className="flex font-chivo-regular">
                {translate("base.next-page")}
                <RightArrow width="35" height="25" />
              </div>
            )
          }
          pageCount={models.pageCount}
          pageRangeDisplayed={3}
          marginPagesDisplayed={0}
          onPageChange={operations.handlePage}
          containerClassName={"flex justify-center items-center space-x-1"}
          pageClassName={
            "px-4 py-2 text-gray-700 hover:underline underline-offset-4"
          }
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"underline underline-offset-4"}
          breakLabel={null}
          onClick={() => {
            window.scrollTo(0, 0);
          }}
        />
      </div>
    </div>
  );
}
